export const getLateDriverDaily = `query MyQuery {
  getDateTimebyDateTime(dateTime: $date) {
    items {
      latesDriverDaily(limit: 10000) {
        items {
          notLate
          late
          driverName
          origin
        }
      }
      latesDaily {
        items {
          late
          notLate
        }
      }
    }
  }
}
`

export const queryHourlyLOTS = `query MyQuery {
  getDateTimebyDate(date:  $date) {
    items {
      dateTime
      statusesHour {
        items {
          successOrder
        }
      }
      latesHour {
        items {
          late
          notLate
        }
      }
    }
  }
}`

export const queryHourlyStat = `query MyQuery {
  getDateTimebyDateTime(dateTime: $dateTime) {
    items {
      statusesDaily {
        items {
          activeDriver
          successOrder
          progressOrder
          issue
          findingDriver
          deriveringOrder
        }
      }
    }
  }
}`
